// ShopItemComponent.tsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface ShopItem {
    id: number;
    price: number;
    image: string;
    name: string;
    position: {
        top: string;
        left: string;
        width: string;
        height: string;
    };
}

interface ShopItemProps {
    item: ShopItem;
    currentCoins: number;
    onBuy: () => void;
}

const ShopItemComponent: React.FC<ShopItemProps> = ({ item, currentCoins, onBuy }) => {
    const [isHovered, setIsHovered] = useState(false);
    const canAfford = currentCoins >= item.price;

    const handleClick = () => {
        if (canAfford) {
            onBuy();
        }
    };

    return (
        <div
            className={`absolute ${isHovered ? 'scale-125' : 'scale-100'} transition-all`}
            style={{
                top: item.position.top,
                left: item.position.left,
                width: item.position.width,
                height: item.position.height,
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
        >
            <img
                src={item.image}
                alt={item.name}
                className="w-full h-full object-contain cursor-pointer"
                style={{
                    filter: isHovered ? `drop-shadow(0 0 2px ${canAfford ? 'green' : 'red'})` : 'none',
                    WebkitFilter: isHovered ? `drop-shadow(0 0 2px ${canAfford ? 'green' : 'red'})` : 'none'
                }}
            />

            <AnimatePresence>
                {isHovered && (
                    <motion.div
                        className="absolute inset-0 flex items-center justify-center"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ pointerEvents: 'none' }} // Allow clicks to pass through
                    >
                        <div className="bg-black/75 text-white px-4 py-2 rounded-md">
                            {!canAfford ? 'Cannot afford this item' : 'Buy!'}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ShopItemComponent;